module.exports = __webpack_public_path__ + "img/img2.2a001fba.png";